var map = {
	"./en/1/nav4_active.png": 42142,
	"./fi/1/nav4_active.png": 74272,
	"./in/1/nav4_active.png": 8554,
	"./th/1/nav4_active.png": 48903,
	"./tw/1/nav4_active.png": 57780,
	"./zh/1/nav4_active.png": 85649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94970;